import { createAsyncThunk } from "@reduxjs/toolkit";
import { notificationFail, notificationSuccess } from "../slices/notificationSlice";
import { API, graphqlOperation } from 'aws-amplify';
import { setLoader, deviceList, DeviceListType } from "../slices/deviceIntegrationSlice";
import { AddProviderMutation, createThirdPartyDeviceProviderMutation, deleteThirdPartyDeviceProviderMutation } from "../../graphql/mutations";
import { getDeviceProviderConfigurationListMutation, getProviderListQuery } from "../../graphql/queries";

export const createThirdPartyDeviceProvider = createAsyncThunk(
  "deviceIntegration/createThirdPartyDeviceProvider",
  async (request: StoreThirdPartyDeviceType, { dispatch, rejectWithValue }) => {
    dispatch(setLoader(true));
    try {
      const response = await API.graphql({
        ...graphqlOperation(createThirdPartyDeviceProviderMutation, { provider: request }), // Fix: use provider instead of createdevicehistory
        authMode: "AMAZON_COGNITO_USER_POOLS",
      }) as { data: { createThirdPartyDeviceProvider: { message: string, success: string } }, errors: any[] };
      console.log(response, 'response')
      if (response?.data?.createThirdPartyDeviceProvider?.success === 'true') {
        dispatch(notificationSuccess(response?.data?.createThirdPartyDeviceProvider?.message || ""));
        dispatch(getIntegrationDevices());
      } else {
        dispatch(notificationFail(response?.data?.createThirdPartyDeviceProvider?.message));
        return rejectWithValue(response?.data?.createThirdPartyDeviceProvider?.message);
      }
      dispatch(setLoader(false));
    } catch (err: any) {
      dispatch(setLoader(false));
      return rejectWithValue(err.errors || err.message);
    }
  }
);

export const getIntegrationDevices = createAsyncThunk("getIntegrationDevices", async (_, { rejectWithValue }) => {
  try {
    const response = await API.graphql({
      ...graphqlOperation(getDeviceProviderConfigurationListMutation),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: { getDeviceProviderConfigurationList: DeviceListType[] }, errors: any[] };
    return response?.data?.getDeviceProviderConfigurationList || []
  } catch (err) {
    return rejectWithValue([]);
    console.error(err);
  }
});
export const deleteIntegrationDevice = createAsyncThunk("deleteIntegrationDevice", async (request: { pk: string, sk: string }, { dispatch, rejectWithValue }) => {
  try {
    const response = await API.graphql({
      ...graphqlOperation(deleteThirdPartyDeviceProviderMutation, { deleteIntegrationDevice: request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: { deleteIntegrationDevice: { message: string, success: string } }, errors: any[] };
    console.log(response, 'response')
    if (response?.data?.deleteIntegrationDevice?.success === 'true') {
      dispatch(notificationSuccess(response?.data?.deleteIntegrationDevice?.message || ""));
      dispatch(getIntegrationDevices());
    } else {
      dispatch(notificationFail(response?.data?.deleteIntegrationDevice?.message));
    }
  } catch (err) {
    dispatch(notificationFail("Unable to delete provider information."));
    // return rejectWithValue();
    console.error(err);
  }
});

export type StoreThirdPartyDeviceType = {
  pk?: string;
  sk?: string;
  provider: string;
  name:string;
  data: string;
  tenantCode:any;
}

export const AddProvider = createAsyncThunk("addProvider", async (_request: any, { dispatch }) => {
  dispatch(setLoader(true));
  try {

    const response = await API.graphql({
      ...graphqlOperation(AddProviderMutation, { addProvider: _request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: any, errors: any[] };

    console.log("response :", response);
    // dispatch(setDeviceList(response?.data?.getThirdPartyDevices))
    dispatch(setLoader(false));

  } catch (err: any) {
    dispatch(setLoader(false));
    console.error("error ::", err)

  }
})

// export const getProviderList = createAsyncThunk("providerList", async (_request: any, { dispatch }) => {
//   try {

//     const response = await API.graphql({
//       ...graphqlOperation(getProviderListQuery, { tenantCode: _request.tenantCode }),
//       authMode: "AMAZON_COGNITO_USER_POOLS",
//     }) as { data: any, errors: any[] };

//     // dispatch(setDeviceList(response?.data?.getThirdPartyDevices))
//     console.log("response :", response);

//   } catch (err: any) {
//     console.error("error ::", err)

//   }
// })